"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementToSVGPath = elementToSVGPath;

var _flow = require("./flow");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function elementToSVGPath(element) {
  if (element.className !== 'Path') {
    throw new Error("Unsupported element: ".concat(element.className));
  } // We know that `segments` and `closed` are defined for Element[className="Path"]


  var segments = (0, _flow.unwrap)(element.segments);
  var closed = (0, _flow.unwrap)(element.closed);
  var normalizedSegments = normalizeCurves(segments);
  return segmentsToSVGPath(normalizedSegments, closed);
}

function normalizeCurves(segments) {
  return segments.map(function (segment) {
    if (segment.length === 6) {
      var _ref = segment,
          _ref2 = _slicedToArray(_ref, 6),
          x = _ref2[0],
          y = _ref2[1],
          x1 = _ref2[2],
          y1 = _ref2[3],
          x2 = _ref2[4],
          y2 = _ref2[5];

      return [x, y, // convert (x1, y1) and (x2, y2) to absolute
      x1 + x, y1 + y, x2 + x, y2 + y];
    }

    return segment;
  });
}

function segmentsToSVGPath(segments, closed) {
  var lines = segmentsToLines(segments, closed);
  var svgLines = lines.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        segmentA = _ref4[0],
        segmentB = _ref4[1];

    var _segmentsToBezier = segmentsToBezier(segmentA, segmentB),
        p1 = _segmentsToBezier.p1,
        p2 = _segmentsToBezier.p2,
        p3 = _segmentsToBezier.p3;

    return "C".concat(p1[0], " ").concat(p1[1], ", ").concat(p2[0], " ").concat(p2[1], ", ").concat(p3[0], " ").concat(p3[1]);
  }).join(' ');

  var _segments$ = _slicedToArray(segments[0], 2),
      x = _segments$[0],
      y = _segments$[1];

  return "M".concat(x, " ").concat(y, " ").concat(svgLines, " ").concat(closed ? 'Z' : '');
}

function segmentsToLines(segments, closed) {
  var lines = [];

  for (var i = 0; i < segments.length - 1; i += 1) {
    var segmentA = segments[i];
    var segmentB = segments[i + 1];
    lines.push([segmentA, segmentB]);
  }

  if (closed) {
    var _segmentA = segments[segments.length - 1];
    var _segmentB = segments[0];
    lines.push([_segmentA, _segmentB]);
  }

  return lines;
}

function segmentsToBezier(segmentA, segmentB) {
  var _addAnchors = addAnchors(segmentA),
      _addAnchors2 = _slicedToArray(_addAnchors, 6),
      p0x = _addAnchors2[0],
      p0y = _addAnchors2[1],
      p1x = _addAnchors2[4],
      p1y = _addAnchors2[5];

  var _addAnchors3 = addAnchors(segmentB),
      _addAnchors4 = _slicedToArray(_addAnchors3, 4),
      p3x = _addAnchors4[0],
      p3y = _addAnchors4[1],
      p2x = _addAnchors4[2],
      p2y = _addAnchors4[3]; // p0 start of curve
  // p1 start handle of curve
  // p2 end handle of curve
  // p3 end of curve


  return {
    p0: [p0x, p0y],
    p1: [p1x, p1y],
    p2: [p2x, p2y],
    p3: [p3x, p3y]
  };
}

function addAnchors(segment) {
  if (segment.length === 6) {
    return segment;
  }

  var _segment = _slicedToArray(segment, 2),
      x = _segment[0],
      y = _segment[1];

  return [x, y, x, y, x, y];
}